import React, { useState, useRef } from 'react';
import { Input, Button, Select, Modal, Upload, message, Form } from 'antd';
import './index.less'
import { useSelector } from 'react-redux'
export default (props) => {
    const recordArr = props.recordArr
    console.log('***recordArr', recordArr);

    // const langValue = useSelector(state=>state.langList.value)
    return (
        <div id="htmlstr" className='htmlstr'>
            {
                recordArr.map(record => {
                    var arr = record['开票日期'].split('-')
                    var record_date = arr[1] + '/' + arr[2] + '/' + arr[0]
                    var money = record['合计金额'].toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')

                    return (
                        <div className='invoice print_gap' id="invoice" key={record['序号']}>
                            <div className='name'>
                                {record['交款人/单位']}
                            </div>
                            <div className='address'>
                                <span>{record['交款人地址']}</span>
                            </div>
                            <div className='TIN'>
                                <span>{record['纳税人识别号']}</span>
                            </div>
                            <div className='detail-top'>
                                <div className='relief'>
                                    Relief Fund :
                                <span>{record['用途']}</span>
                                </div>
                                <div className='donate'>
                                    <div>Total Donation : </div>
                                    <div className='donate-box'>
                                        <div className='donate-top'>PHP{money}</div>
                                        <div className='donate-bot'>PHP{money}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='word'>
                                {record.ch_word + record.en_word}
                            </div>
                            <div className='number'>
                                {record['票据号码']}
                            </div>
                            <div className='date'>{record_date}</div>
                        </div>
                    )
                })
            }
        </div>

    )
}